import { SVGProps, Ref, forwardRef } from 'react';

export const HeartOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m12 9.724-1.474-2.105C8.723 5.046 6.455 4.512 4.805 4.93 3.125 5.353 1.8 6.802 1.8 8.952c0 1.653 1.186 3.45 3.488 5.4 1.971 1.67 4.42 3.173 6.712 4.55 2.292-1.377 4.74-2.88 6.712-4.55 2.302-1.95 3.488-3.747 3.488-5.4 0-1.967-1.295-3.452-3.03-3.917-1.665-.446-3.913.038-5.696 2.584zM12 21C7 18 0 13.952 0 8.952 0 3.47 6.377.83 10.806 5.17q.628.613 1.194 1.417a9.8 9.8 0 0 1 1.197-1.413C17.626.879 24 3.747 24 8.953c0 5-7 9.047-12 12.047"
                fill="currentColor"
            />
        </g>
    </svg>
));
HeartOutlinedSize24Glyph.displayName = 'HeartOutlinedSize24Glyph';
